export const LulaExampleModalTypes = {
  INVOICE: 'invoice',
  RECEIPT: 'receipt',
};
